import React from 'react';

import Typography from '../../../../library/typography/typography';

import { getStockCount } from '../../../../shared/utils/product/product';

import { Maybe } from '../../../../shared/types/graphql-types';

import styles from './product-availability-staggered-entry.scss';

interface ProductAvailabilityStaggeredEntryProps {
  label: string;
  stockCount: Maybe<number> | undefined;
}

function ProductAvailabilityStaggeredEntry(
  props: ProductAvailabilityStaggeredEntryProps
) {
  const { label, stockCount } = props;
  return (
    <div className={styles['staggered-entry']}>
      <div className={styles['axle-type']}>{label}: </div>
      <Typography
        className={styles['stock']}
        size="small"
        tag="div"
        weight="black"
      >
        {getStockCount(stockCount)} in Stock
      </Typography>
    </div>
  );
}

export default ProductAvailabilityStaggeredEntry;
